import React, { useContext } from "react";
import { styled, Text, TokenTextAppearance, TokenTextColor } from "@volkswagen-onehub/components-core";
import { Logo } from "@volkswagen-onehub/icons-core";
import { getTranslations } from "../../translations";
import { ResultsView, ResultsViewContext } from "../../utils/results-view-context";
import { Language } from "../../types";

interface Props {
  lang: Language;
  appearance?: TokenTextAppearance;
  lineBreak?: boolean;
  hideStock?: boolean;
  hideLogo?: boolean;
  color?: string;
};

type StyledLogoType = {
  color?: string;
}

const StyledLogo = styled(Logo)<StyledLogoType>`
  width: 100%;
  height: 100%;
  ${ props => props.color && `color: ${props.color}` };
`;

const LogoWrapper = styled.div``;

const CopyContainer = styled.div<{view : ResultsView}>`
  display: flex;
  align-items: center;
  column-gap: 0.4rem;
  ${props => props.color && `color: ${props.color}` };
`;

const StyledText = styled(Text)`
  margin: 0;
  display: flex;
  align-items: center;
  line-height: 1;
  column-gap: 0.4rem;
`;

// quick hard coded solution, component only used in one place — find way to determine equivalent font keys from TokenTextAppearance prop
const Container = styled.div<Props>`
  display: flex;
  ${({theme, lineBreak}) => `
    // margin: 0 0 ${theme.fonts.headline[200].fontSize};
    column-gap: calc(${theme.fonts.headline[200].fontSize} * 8/11);
    ${LogoWrapper} {
      width: calc(${lineBreak ? 3 : 2} * (${theme.fonts.headline[200].fontSize} * 8/11));
      height: calc(3 * (${theme.fonts.headline[200].fontSize} * 8/11));
    }
    ${StyledText} {
      line-height: calc(${lineBreak ? 1.1 : 1} * ${theme.fonts.headline[200].fontSize});
      white-space: ${lineBreak ? 'pre-wrap' : 'nowrap'};
    }
  `}
`;

export const CPOLogo = ({lang, appearance, lineBreak = false, hideStock = false, hideLogo = false, color}: Props) => {
  const copy = lang === Language.FR ? "VW d’occasion certifiée" : `Certified Pre-Owned`;

  const trans = getTranslations();

  const view = useContext(ResultsViewContext).value;

  return (
    <Container lang={lang} appearance={appearance} lineBreak={lineBreak}>
      {!hideLogo &&
        <LogoWrapper>
          <StyledLogo color={color} />
        </LogoWrapper> }
      <CopyContainer view={view} color={color}>
        <StyledText
          appearance={appearance}
          color={TokenTextColor.inherit}
          bold
        >
          { copy }

        </StyledText>

        {!hideStock && <Text bold={false} appearance={appearance} color={TokenTextColor.inherit}>{trans.results.vehicleType.inStock}</Text>}

      </CopyContainer>
    </Container>
  )
};
